import RequireAccessPageId from 'constants/RequireAccessPageId';

export const checkRequirePage = (menuId) => {
  return Object.keys(RequireAccessPageId).some((key) => RequireAccessPageId[key] === menuId);
};
